import { render, staticRenderFns } from "./FeesTable.vue?vue&type=template&id=a4791bec&"
import script from "./FeesTable.vue?vue&type=script&lang=js&"
export * from "./FeesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports